import httpClient from "./api";

// const END_POINT = ;

const getRequest = (endpoint, options = {}) => httpClient.get(endpoint, {...options});
const getOneRequest = (endpoint, id, options = {}) => httpClient.get(endpoint + '/' + id, {...options});
const deleteRequest = (endpoint, id, options = {}) => httpClient.delete(endpoint + '/' + id, {...options});
const postRequest = (endpoint, data, options = {}) => httpClient.post(endpoint, JSON.stringify(data), {...options});
const pathRequest = (endpoint, data, options = {}) => httpClient.put(endpoint + '/' + data.id, JSON.stringify(data), {...options});

export {
    getRequest,
    getOneRequest,
    postRequest,
    pathRequest,
    deleteRequest
}